import axios, { AxiosRequestConfig } from 'axios';

import type { Environment } from '../interfaces';
import { hostsConfig } from '../utils';
import type { ConfigType } from '../utils/config.type';

interface AxiosInterceptorTokenStorage {
  get: () => Promise<string>;
}

export const AxiosInterceptor = (
  tokenStorage: AxiosInterceptorTokenStorage,
  environment?: Environment
) => {
  axios.interceptors.request.use(
    async function (requestConfig) {
      const token = await tokenStorage.get();
      if (token && environment) {
        addAuthorizationTokenWhenNeeded(
          token,
          hostsConfig[environment],
          requestConfig
        );
      }

      return requestConfig;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  ///
  //  DO NOT REMOVE: Uncomment in case needed on dev to review the response or if need to add something to response process
  ///
  // axios.interceptors.response.use(
  //   function (response) {
  //     return response;
  //   },
  //   function (error) {
  //     return Promise.reject(error);
  //   }
  // );
};

function addAuthorizationTokenWhenNeeded(
  token: string,
  config: ConfigType,
  requestConfig: AxiosRequestConfig
) {
  if (!requestConfig) {
    return;
  }

  const url = requestConfig.baseURL || requestConfig.url;
  if (!url) {
    return requestConfig;
  }
  const needsAuthorization = isUrlListed(url, config.authorizationList);
  if (needsAuthorization && requestConfig.headers) {
    requestConfig.headers.Authorization = token;
  }
  const needsBearerAuthorization = isUrlListed(url, config.bearerList);
  if (needsBearerAuthorization && requestConfig.headers) {
    requestConfig.headers.Authorization = `Bearer ${token}`;
  }
  return requestConfig;
}

function isUrlListed(url: string, urlList: string[]) {
  const { hostname: urlHostname } = new URL(url);

  return urlList.some((urlItem) => {
    const { hostname } = new URL(urlItem);
    return hostname === urlHostname;
  });
}
